module.exports = __webpack_public_path__ + "static/Ignite-f7ef0a84a62d35dcf78f3c28a1c12794.jpg";